
export default {
  props: ['data'],
  data () {
    return {
      slide: 1
    }
  },
  methods: {
    CloseGalley () {
      this.$emit('clicked', false)
    }
  },
  mounted () {
    console.log(this.data)
  }
}
